import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    changeActualPasswordRequest: ['response'],
    changeActualPasswordSuccess: ['response', 'loading'],
    changeActualPasswordFailure: ['error'],
})

export const changeActualPasswordTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const changeActualPasswordRequest = state => state.merge({ loading: true })

const changeActualPasswordSuccess = (state, { response }) =>
    state.merge({
        error: false,
        success: true,
        loading: false,
        response,
    })

const changeActualPasswordFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        loading: false,
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.CHANGE_ACTUAL_PASSWORD_REQUEST]: changeActualPasswordRequest,
    [Types.CHANGE_ACTUAL_PASSWORD_SUCCESS]: changeActualPasswordSuccess,
    [Types.CHANGE_ACTUAL_PASSWORD_FAILURE]: changeActualPasswordFailure,
})
